import { paths } from '@/constants/paths';

export const NUKI_CLUB = 'Nuki Club';

export const myAccountLinks = [
  { href: paths.myAccount, label: 'Dashboard' },
  { href: paths.profile, label: 'Profile' },
  { href: paths.orders, label: 'Orders' },
  { href: paths.devices, label: 'My Devices' },
  { href: paths.services, label: 'Services' },
  { href: paths.club, label: NUKI_CLUB },
];
